export default __webpack_public_path__ + "static/media/logo20.8707d7d1.png";